module.exports = __webpack_public_path__ + "img/telegram_blue.9cf6cd8b.svg";